export default {
  data() {
    return {
      resizeStyle: null,
    }
  },
  methods: {
    setResizeStyle(resizeStyle) {
      this.resizeStyle = resizeStyle
      this.$emit('resize', resizeStyle)
    },
  },
}
